import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Modal, Button, Row, Select, Form } from 'antd';
import { get } from 'lodash';
import TncPreview from '../TncPreview/TncPreview.component';
import './TncPreviewModal.style.less';
const { Option } = Select;
class TncPreviewModal extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      lang: props.selectedLang || 'en',
    };
  }

  render() {
    const { tnc, modalVisible, onClose, title, showControl } = this.props;
    return (
      <Modal
        title={<Row className="tnc-modal-title">{title}</Row>}
        visible={modalVisible}
        footer={null}
        closable={false}
      >
        {showControl && (
          <div className="tnc-control-menu">
            {/* <Form.Item label="Latest File Version" colon={false}>
              <Input
                placeholder={get(tnc, 'fileVersion')}
                size="large"
                disabled
              />
            </Form.Item> */}
            <Form.Item label="Terms & Condition Preview Language" colon={false}>
              <Select
                size="large"
                style={{ width: '100%', marginBottom: 20 }}
                value={this.state.lang}
                onChange={lang => {
                  this.setState({ lang });
                }}
              >
                <Option key="en" value="en">
                  English
                </Option>
                <Option key="id" value="id">
                  Bahasa
                </Option>
              </Select>
            </Form.Item>
          </div>
        )}

        <div className="tnc-preview-body">
          <TncPreview
            style={{ transform: 'scale(0.8)', margin: -50, marginTop: -70 }}
            htmlContent={get(tnc, `tncContent.${this.state.lang}`)}
          />

          <Button className="btn-cancel" onClick={onClose}>
            Back
          </Button>
        </div>
      </Modal>
    );
  }
}

TncPreviewModal.propTypes = {
  tnc: PropTypes.object,
  modalVisible: PropTypes.bool,
  onClose: PropTypes.func,
  selectedLang: PropTypes.bool,
  title: PropTypes.string,
  showControl: PropTypes.bool,
};

export default TncPreviewModal;
